const formations = [
	{
		id: 'module1',
		title: 'Risques électriques et Habilitation',
		duration: 2,
		subFormations: [
			'Introduction à la formation et aux objectifs',
			'Connaissances de base en électricité',
			'Identification des risques électriques',
			'Réglementation et normes de sécurité',
			"Habilitation électrique : Processus et niveaux d'habilitation",
			'Prévention des risques électriques',
			'Équipements de protection individuelle (EPI)',
			"Plans d'urgence et premiers secours",
			'Interventions sur les installations électriques'
		]
	},
	{
		id: 'module2',
		title: 'Règles techniques et de sécurité liées aux installations électriques BT',
		duration: 2,
		subFormations: [
			'Typologie et constituants des branchements électriques BT',
			'Dimensionnement des branchements électriques BT',
			'Réalisation des branchements électriques BT',
			"Norme NF C 15-100 dans l'habitat",
			"Risques & dangers de l'électricité",
			'Habilitation électrique électricien BT',
			'Environnement électrique',
			'Principes généraux de la prévention du risque électrique'
		]
	},
	{
		id: 'module3',
		title: 'Consignation électrique BT & HTA NFC 18 510',
		duration: 2,
		subFormations: [
			"Les causes d'accidents électriques",
			'Principes généraux de la prévention liés aux travaux hors tension',
			"Types d'opérations sur les ouvrages et installations électriques selon les principes généraux de prévention",
			'Equipements de protection individuelle & collective',
			'Procédure de consignation électrique',
			'Définition de la consignation',
			'Les cinq opérations de la consignation électrique',
			'Consignation en une étape – Consignation en deux étapes',
			'Attestation de consignation',
			'La déconsignation',
			"Préparation de la consignation & l'analyse des risques associés",
			"Mise en œuvre de la consignation électrique sur différents types d'ouvrages"
		]
	},
	{
		id: 'module4',
		title: 'Qualité des travaux électriques',
		duration: 1,
		subFormations: [
			'Introduction sur des travaux électriques',
			'Sécurité électrique',
			'Normes et réglementations',
			'Planification des travaux électriques',
			'Exécution des travaux électriques',
			'Vérification et tests',
			'Gestion des incidents et des imprévus',
			'Communication et relation client'
		]
	},
	{
		id: 'module5',
		title: 'Notion de base de la Maintenance',
		duration: 1,
		subFormations: [
			'Présentation de la politique maintenance',
			'Les qualifications des opérateurs et acteurs dans la politique de maintenance',
			"Se situer dans la politique de la maintenance de l'entreprise",
			'Les types de maintenance',
			'Préparer son intervention de maintenance',
			'Faire une synthèse du plan de maintenance'
		]
	},
	{
		id: 'module6',
		title: 'Risques des Travaux en hauteur',
		duration: 1,
		subFormations: [
			'Définition des risques',
			'Situations des travaux en hauteur',
			"Conséquences d'une chute en hauteur",
			'Equipements des protections',
			'Règlementation et prévention des risques',
			"Conduite à tenir en cas d'accident"
		]
	},
	{
		id: 'module7',
		title: 'Technologie du réseau souterrain et équipements HTA',
		duration: 1,
		subFormations: [
			"Types d'équipements électriques HTA (Poste et réseau)",
			"Procédures d'installation et de maintenance",
			'Dimensionnement des tranchée et technique de pose des réseaux HTA',
			'Test et mise en service des équipements',
			'Principes de base des réseaux HTA',
			'Conception et architecture des réseaux HTA',
			'Entretien et gestion des réseaux HTA'
		]
	},
	{
		id: 'module8',
		title: 'Hygiène et sécurité sur les chantiers travaux',
		duration: 2,
		subFormations: [
			"Réglementation relative à l'hygiène, l'organisation et l'SST du chantier",
			"Démarche d'évaluation des risques professionnels",
			'Risques des chantiers travaux',
			'Organisation du chantier',
			'Signalisation temporaire',
			'Travaux au voisinage de réseaux',
			'Engins de chantier',
			'Sécurisation des tranchées : blindage et talutage',
			'Port des EPI sur le chantier',
			'Hygiène et propreté'
		]
	},
	{
		id: 'module9',
		title: 'Les règles qui sauvent',
		duration: 1,
		subFormations: [
			'Risques des Charges qui tombent',
			'Risques des Trajectoires',
			'Risques des Espaces confines',
			'Risques des Profondeurs des tranchés',
			'Risques des Hauteurs',
			'Risques de présence des Energies',
			'Risques des Incendies',
			"Risques d'utilisation de Téléphone",
			"Risques de prise d'alcool",
			'Risques des Tournés et recules',
			'Défusion des séquences vidéo des accidents sur des chantiers des travaux, causés par le non-respect des règles et consignes',
			"Echanges sur le retour d'expériences sur les accidents ou presque accidents rencontrés par les participants",
			'Sensibilisation sur le respect des règles qui sauvent aux chantiers des travaux'
		]
	},
	{
		id: 'module10',
		title: 'Rôle de chargé de travaux et intervenants sur chantiers de travaux Electrique',
		duration: 1,
		subFormations: [
			'Planification des Travaux',
			'Supervision et Coordination des travaux',
			'Gestion des Matériaux et des Équipements',
			"Maîtrise des techniques et des normes de l'électricité",
			'Gérer des équipes et à coordonner plusieurs intervenants',
			'Compétences en Sécurité',
			"Capacité à réagir aux imprévus et à s'adapter aux contraintes du chantier",
			'Aptitude à motiver et à diriger une équipe'
		]
	},
	{
		id: 'module11',
		title: 'Secourisme',
		duration: 1,
		subFormations: [
			'Rôle du Sauveteur Secouriste au Travail',
			"Plan d'intervention SST",
			'Se protéger et protéger',
			'Examiner la victime',
			'Alerter ou Faire alerter et Secourir la victime',
			'Arrêter un saignement abondant',
			'Traiter un étouffement total',
			'Réaliser une réanimation cardio-pulmonaire RCP',
			'Mettre la victime en position latérale de sécurité PLS',
			"Assister une personne qui souffre d'un malaise",
			'Traiter les brûlures thermiques et chimique',
			"Donner une position d'attente à une victime qui souffre d'une fracture supposée",
			'Traiter les blessures, les morsures et les plaîs'
		]
	},
	{
		id: 'module12',
		title: 'Technologie des réseaux souterrain BT et HTA et montage des Boites de jonction et extrémité',
		duration: 1,
		subFormations: [
			'Présentation du réseau HTA et BT',
			'Présentation du réseau souterrain HTA et BTA',
			'Présentation des accessoires de raccordement',
			'Présentation de l’outillage de préparation du câble',
			'Recommandations de pose de câbles souterrain HTA et BT',
			'Techniques de montage des boîtes de jonctions & extrémités sur câbles souterrain HTA et BT'
		]
		
	},
];

export default formations;
